<script>
    import {apiUrl} from '../config.svelte';
    import ProjectSelect from '../Components/ProjectSelect.svelte'
    import {Nav ,NavItem,NavLink } from 'sveltestrap'
    import { UncontrolledCollapse, Button, Card ,Table,Input,CustomInput} from 'sveltestrap';
    export let user;

    let tab="pm"
    let collapse
    let chosenProject;
    function projectChanged(e){
        expect={}
        collapse=undefined;
        tab="pm"
        chosenProject = e.detail.value
    }

    let pmData=undefined
    function loadProjectConfig(proj){
        pmData=undefined
        if(proj!=undefined){
            fetch(apiUrl+"ivm",{
                credentials: "include",
                method:"POST",
                cors:'no-cors',
                body:JSON.stringify(proj)
            })
            .then(x=>x.json())
            .then(x=>{
                if (x.result){
                    pmData = x.pmData
                }else{
                    alert("ошибка сервера")
                }
            })
            .catch(()=>{
                alert("ошибка сервера")
            })
        }   
    }

    let expect={

    }

    function loadExpectMain(dt){
        console.log('changed_date',dt)
        expect={};
        if(dt)
        {
            let month = dt.split('-')[1]
            let year = dt.split('-')[0]
            console.log('parsed',year,month)
            fetch(apiUrl+"project-config",{
                credentials: "include",
                method:"POST",
                cors:'no-cors',
                body:JSON.stringify({method:"get-expect-main",month:month,year:year})
            })
            .then(x=>x.json())
            .then(x=>{
                if (x.result){
                    if (x.data.year && x.data.month)
                        expect.month = `${x.data.year}-${x.data.month.toString().length>1?x.data.month.toString():'0'+x.data.month.toString()}`
                    else 
                        expect.month = dt
                    if (x.data.pd || x.data.pd==0)
                        expect.pd= x.data.pd
                    if (x.data.hours || x.data.hours==0)
                        expect.hours= x.data.hours
                    expect= expect
                    console.log(expect)
                }else{
                    alert("ошибка сервера")
                }
            })
            .catch((e)=>{
                console.log(e)
                alert("ошибка сервера")
            })
        }
    }

    function loadExpect(proj,dt){
        console.log('changed_date',dt)
        expect={};
        if(dt)
        {
            let month = dt.split('-')[1]
            let year = dt.split('-')[0]
            console.log('parsed',year,month)
            fetch(apiUrl+"project-config",{
                credentials: "include",
                method:"POST",
                cors:'no-cors',
                body:JSON.stringify({method:"get-expect",project:proj.Project,month:month,year:year})
            })
            .then(x=>x.json())
            .then(x=>{
                if (x.result){
                    if (x.data.year && x.data.month)
                        expect.month = `${x.data.year}-${x.data.month.toString().length>1?x.data.month.toString():'0'+x.data.month.toString()}`
                    else 
                        expect.month = dt
                    if (x.data.pd || x.data.pd==0 )
                        expect.pd= x.data.pd
                    if (x.data.hours || x.data.hours==0 )
                        expect.hours= x.data.hours
                    expect= expect
                    console.log(expect)
                }else{
                    alert("ошибка сервера")
                }
            })
            .catch((e)=>{
                console.log(e)
                alert("ошибка сервера")
            })
        }
    }
    function saveExpectMain(){
        console.log(expect,user)

        fetch(apiUrl+"project-config",{
            credentials: "include",
            method:"POST",
            cors:'no-cors',
            body:JSON.stringify({method:"put-expect-main",expect:expect,user:user})
        })
        .then(x=>x.json())
        .then(x=>{
            if (x.result){
                
            }else{
                alert("ошибка сервера")
            }
        })
        .catch(()=>{
            alert("ошибка сервера")
        })
    }
    function saveExpect(){
        console.log(expect,user,chosenProject)

        fetch(apiUrl+"project-config",{
            credentials: "include",
            method:"POST",
            cors:'no-cors',
            body:JSON.stringify({method:"put-expect",project:chosenProject.Project,expect:expect,user:user})
        })
        .then(x=>x.json())
        .then(x=>{
            if (x.result){
                
            }else{
                alert("ошибка сервера")
            }
        })
        .catch(()=>{
            alert("ошибка сервера")
        })
    }
</script>
<div style="width:350px">
    <ProjectSelect on:change={projectChanged}/>
</div>
{#if chosenProject}
    <Nav tabs>
        <NavItem>
            <NavLink  active={tab=="pm"} on:click={()=>{tab="pm"}}>ПМ</NavLink>
        </NavItem>
    </Nav>
    <div style="height:calc(100% - 100px);box-shadow:0px 0px 2px grey;width:100%;overflow:auto">
        <Button block color="outline-dark" id="expects" on:click={()=>{collapse="Прогнозы"}}>Прогнозы</Button>
        {#if collapse=="Прогнозы"}
        <Card body>
            <Table size="sm" hovered style="width:auto">
                <tr>
                    <td>месяц</td>
                    <td><CustomInput style="width:300px;" type="month" on:change={(e)=>{loadExpect(chosenProject,e.target.value)}} /> </td>
                </tr>
                <tr>
                    <td>прогноз часов</td>
                    <td><Input type="number" style="width:300px;" bind:value={expect.hours}  /> </td>
                </tr>
                <tr>
                    <td>прогноз ПД/час</td>
                    <td><Input type="number" style="width:300px;" bind:value={expect.pd}  /> </td>
                    <!--on:change={(e)=>{expect.pd=e.target.value}}-->
                </tr>
                <tr>
                    <td></td>
                    <td><Button color="success" outline on:click={()=>{saveExpect()}}>Сохранить</Button> </td>
                </tr>
            </Table>
        </Card>
        {/if}
    </div>
{:else}
    <Nav tabs>
        <NavItem>
            <NavLink  active={tab=="pm"} on:click={()=>{tab="pm"}}>ПМ</NavLink>
        </NavItem>
    </Nav>
    <div style="height:calc(100% - 100px);box-shadow:0px 0px 2px grey;width:100%;overflow:auto">
        <Button block color="outline-dark" id="expects" on:click={()=>{collapse="Прогнозы"}}>Прогнозы</Button>
        {#if collapse=="Прогнозы"}
        <Card body>
            <Table size="sm" hovered style="width:auto">
                <tr>
                    <td>месяц</td>
                    <td><CustomInput style="width:300px;" type="month" on:change={(e)=>{loadExpectMain(e.target.value)}} /> </td>
                </tr>
              
                <tr>
                    <td>плановый ПД</td>
                    <td><Input type="number" style="width:300px;" bind:value={expect.pd}  /> </td>
                    <!--on:change={(e)=>{expect.pd=e.target.value}}-->
                </tr>
                <tr>
                    <td></td>
                    <td><Button color="success" outline on:click={()=>{saveExpectMain()}}>Сохранить</Button> </td>
                </tr>
            </Table>
        </Card>
        {/if}
    </div>
{/if}